var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcBackBreadCum(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#F0F2F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4277 7.90039C19.5171 7.9004 19.6054 7.91937 19.6875 7.95605C19.7693 7.99266 19.8434 8.04562 19.9053 8.1123C19.9674 8.17905 20.0165 8.25837 20.0498 8.34473C20.083 8.43097 20.0996 8.52322 20.0996 8.61621C20.0996 8.70931 20.0831 8.80233 20.0498 8.88867C20.0332 8.93177 20.0124 8.97293 19.9883 9.01172L19.9053 9.12012L13.5166 16L19.9053 22.8799C20.0304 23.0146 20.0996 23.1962 20.0996 23.3838C20.0996 23.5714 20.0304 23.7529 19.9053 23.8877C19.7799 24.0226 19.6084 24.0996 19.4277 24.0996C19.2471 24.0996 19.0755 24.0226 18.9502 23.8877L12.0947 16.5039C12.0326 16.4372 11.9835 16.3578 11.9502 16.2715C11.917 16.1853 11.9004 16.0929 11.9004 16C11.9004 15.907 11.917 15.8148 11.9502 15.7285C11.9835 15.6422 12.0326 15.5628 12.0947 15.4961L18.9502 8.1123C19.0121 8.04562 19.0861 7.99265 19.168 7.95605C19.2501 7.91937 19.3384 7.90039 19.4277 7.90039Z",
    fill: "#646D69",
    stroke: "#646D69",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBackBreadCum);
export default __webpack_public_path__ + "static/media/ic-back-breadCum.d21dcb0ce5f49169ca0a9f85e35640be.svg";
export { ForwardRef as ReactComponent };